import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as Utils from '../../../utils'
import * as ReportConstants from '../constants'
export * from '../constants'

export const CHART = Utils.join(Request.SWITCH, 'CHART')
export const CHART_FILTER = 'CHART_FILTER'

export const AggregationNames = {
  DateField: 'message_send_date',
  DateHistogram: 'date_histogram',
  FieldName: Elasticsearch.DocumentFieldNames.EventName,
}
export const FormConstants = Form.createConstantsMap(CHART_FILTER)
export const FieldNames = {
  community: 'community',
  dateRange: ReportConstants.DateRangeFieldNames.dateRange,
  endDate: ReportConstants.DateRangeFieldNames.endDate,
  groupBy: 'groupBy',
  startDate: ReportConstants.DateRangeFieldNames.startDate,
  totalsVsUniques: 'totalsVsUniques',
}
export type DropdownValues = 'totalCount' | 'uniqueCount' | 'totalPercentage' | 'uniquePercentage'
export const TotalsVsUniquesMap: {[key: string]: DropdownValues} = {
  TotalCount: 'totalCount',
  TotalPercentage: 'totalPercentage',
  UniqueCount: 'uniqueCount',
  UniquePercentage: 'uniquePercentage',
}

export const TotalsVsUniquesLabelMap = {
  [TotalsVsUniquesMap.TotalCount]: ['Total Opens Count', 'Total Clicks Count'],
  [TotalsVsUniquesMap.TotalPercentage]: ['Total Open Rate', 'Total Click Rate'],
  [TotalsVsUniquesMap.UniqueCount]: ['Unique Opens Count', 'Unique Clicks Count'],
  [TotalsVsUniquesMap.UniquePercentage]: ['Unique Open Rate', 'Unique Click Rate'],
}



// WEBPACK FOOTER //
// ./src/pages/reports/analytics/constants.ts